import { Breadcrumb } from "@hellocarbo/lasagne";
import { use } from "react";
import { Outlet, useParams } from "react-router";

import { FeaturesContext, PortalContainerContext } from "@/contexts";
import useBreadcrumbs from "@/hooks/useBreadcrumbs";
import { cn } from "@/utils/classes";

import { overlayedClassname } from "./Review";

const CollectBreadcrumbs = () => {
  const { container } = use(PortalContainerContext);
  const params = useParams();
  const { crumbs } = useBreadcrumbs();
  const { featureFlags } = use(FeaturesContext);

  // We're on import deposit page index if the URL contains import_deposits but not the importId
  const isImportDepositIndex =
    crumbs.some((crumb) => crumb.href.includes("import_deposits")) &&
    !params?.importId;

  return (
    <>
      <div
        className={cn(
          isImportDepositIndex && featureFlags?.["import_deposit_view_react"]
            ? "px-xl mt-sm"
            : overlayedClassname
        )}
      >
        <Breadcrumb portalContainer={container!} crumbs={crumbs} />
      </div>
      <Outlet />
    </>
  );
};

export default CollectBreadcrumbs;
